/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
// import CardPMSGuestLine from "../CardItem/CardPMSGuestLine";
//import CardPMSHotelTime from "../CardItem/CardPMSHotelTime";
// import CardPMSOpera from "../CardItem/CardPMSOpera";
import CardPMS from "../CardItem/CardPMS";
import CardInventory from "../CardItem/CardInventory";
import CardInventoryMC from "../CardItem/CardInventoryMC";

const useStyles = makeStyles((theme) => ({
  rootTitle: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  textCancel: {
    color: "inherit",
    border: "1px solid rgba(0, 0, 0, 0.23)",
  },
}));

const DialogPMS = (props) => {
  console.log(props);

  const classes = useStyles();
  const { onClose, open, id, title, setting } = props;

  const DialogTitle = (props) => {
    const { children, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.rootTitle} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  };

  const handleCancel = () => {
    onClose();
  };

  const CheckIntefaceType = () => {
    if (setting.InterfaceType === "Inventory" && setting.InterfaceName !== "MC") {
      return <CardInventory id={id} title={title} setting={setting} />;
    } else if (setting.InterfaceType === "Inventory" && setting.InterfaceName === "MC") {
      return <CardInventoryMC id={id} title={title} setting={setting} />;
    } else {
      return <CardPMS id={id} title={title} setting={setting} />;
    }
  };

  return (
    <Dialog fullWidth maxWidth="sm" aria-labelledby="confirmation-dialog-title" open={open}>
      <DialogTitle id="customized-dialog-title" onClose={handleCancel}>
        {title}
      </DialogTitle>
      <DialogContent dividers style={{ padding: 4 }}>
        {CheckIntefaceType()}
      </DialogContent>
    </Dialog>
  );
};

export default DialogPMS;
